export default __webpack_public_path__ + "static/media/featured-artist-artwork-1.5d3e7223.png";